import styled from 'styled-components';

import { getVariant } from '@/themes/typographyUtilis';

export const TimePickerCalendarContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  pointer-events: none;

  .flatpickr-calendar {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2) !important;
    border: 1px solid ${({ theme }) => theme.colors.border} !important;
    border-radius: 8px !important;
    background: ${({ theme }) => theme.colors.background.light} !important;
    pointer-events: auto;
  }

  .flatpickr-calendar.hasTime.noCalendar {
    width: 150px !important;
  }

  .flatpickr-time,
  .flatpickr-calendar.hasTime .flatpickr-time {
    background: ${({ theme }) => theme.colors.background.light} !important;
  }

  .flatpickr-calendar.hasTime .flatpickr-time {
    border-top: 1px solid ${({ theme }) => theme.colors.background.medium} !important;
  }

  .flatpickr-time input,
  .flatpickr-time .flatpickr-time-separator,
  .flatpickr-time .flatpickr-am-pm {
    color: ${({ theme }) => theme.colors.primaryText} !important;
  }

  .flatpickr-time input:hover,
  .flatpickr-time .flatpickr-am-pm:hover,
  .flatpickr-time input:focus,
  .flatpickr-time .flatpickr-am-pm:focus {
    background: ${({ theme }) => theme.colors.background.medium} !important;
  }

  .flatpickr-time .numInputWrapper {
    background: ${({ theme }) => theme.colors.background.light} !important;
  }

  .flatpickr-time .numInputWrapper span.arrowUp::after {
    border-bottom-color: ${({ theme }) => theme.colors.primaryText} !important;
  }

  .flatpickr-time .numInputWrapper span.arrowDown::after {
    border-top-color: ${({ theme }) => theme.colors.primaryText} !important;
  }

  .numInputWrapper span {
    border-color: ${({ theme }) => theme.colors.background.medium} !important;
  }

  .numInputWrapper span:hover {
    background: ${({ theme }) => theme.colors.background.medium} !important;
  }
`;

export const TimePickerInputWrapper = styled.div`
  position: relative;

  input.flatpickr-input,
  input[readonly] {
    width: 100%;
    border: 1px solid
      ${({ theme }) => (theme.theme === 'light' ? theme.colors.border : 'transparent')};
    border-radius: 4px;
    padding: 13px 20px;
    padding-right: 40px;
    background: ${({ theme }) => theme.colors.background.light};
    color: ${({ theme }) => theme.colors.primaryText};
    ${getVariant({ variant: 'body1-normal' })};
    text-align: left;
    cursor: pointer;
  }

  input.flatpickr-input::placeholder,
  input[readonly]::placeholder {
    opacity: 0.75;
    color: ${({ theme }) => theme.colors.secondaryText};
  }

  input.flatpickr-input:focus,
  input[readonly]:focus,
  input.flatpickr-input.active,
  input[readonly].active {
    outline: none;
    border-color: ${({ theme }) => theme.colors.active};
  }
`;

export const TimePickerIcon = styled.span`
  position: absolute;
  top: 50%;
  right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.colors.secondaryText};
  transform: translateY(-50%);
  pointer-events: none;
`;
